import { useEffect, useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";
import { reapplyStoredThemeMode } from "../../utils/themeMode";

export default function AdminThemeSync() {
    const location = useLocation();

    useLayoutEffect(() => {
        reapplyStoredThemeMode();
    }, [location.pathname]);

    useEffect(() => {
        const applyNow = () => {
            reapplyStoredThemeMode();
        };

        // Immediate + after route CSS/components render
        applyNow();

        const t1 = window.setTimeout(applyNow, 0);
        const t2 = window.setTimeout(applyNow, 80);
        const t3 = window.setTimeout(applyNow, 250);

        window.addEventListener("focus", applyNow);
        document.addEventListener("visibilitychange", applyNow);

        return () => {
            window.clearTimeout(t1);
            window.clearTimeout(t2);
            window.clearTimeout(t3);
            window.removeEventListener("focus", applyNow);
            document.removeEventListener("visibilitychange", applyNow);
        };
    }, [location.pathname]);

    return null;
}